// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"137":"b6b10d1d","282":"5956fe59","303":"131243ca","349":"826a590e","366":"b220a0ce","409":"9da383e2","450":"80379db6","527":"7ada59ba","550":"9fcc7bc4","680":"cfc1d9b4","913":"b975178b","977":"223ea1d4"}[chunkId] + ".chunk.js";
};